/*
 * Project: bellcloud
 * File: packages/protocols/mini/cmds.ts
 * Author: SWAN
 * Created: 2025-08-27 14:35:13
 * Description:
 */

export enum ClassID {
  INFORMATION = 0x01,
  MONITORING = 0x02,
  CONFIGURATION = 0x03,
  CALIBRATION = 0x04,
  FILE_TRANSFER = 0x10,
  MAINTENANCE = 0x11,
}
